const fixedContent =
  'The parties will attempt to resolve any dispute arising out of or relating to this Agreement' +
  ' through friendly negotiations amongst the parties.  If the matter is not resolved by negotiation ';

const answers = [
  'the parties will submit the dispute to mediation in accordance with any statutory rules of mediation.',
  'all claims, disputes, or disagreements will be submitted to binding arbitration under the jurisdiction of <STATE>.',
  'all claims, disputes, or disagreements related to this Agreement shall be subject exclusively to the jurisdiction' +
    ' of the federal and state courts located in <STATE>.',
];

export default (options, state) => {
  let content = '';
  let checked = true;

  if (options.field1 === true) {
    content = answers[0];
  }

  if (options.field2 === true) {
    if (content !== '') {
      content += '  If the dispute is not resolved ';
    }
    if (state === '') {
      content += answers[1].replace(
        '<STATE>',
        `<i><u>&nbsp;&nbsp;select a region&nbsp;&nbsp;</u></i>`
      );
      checked = false;
    } else {
      content += answers[1].replace(
        '<STATE>',
        state === 'extra_region'
          ? `<i><u>&nbsp;&nbsp;select a region&nbsp;&nbsp;</u></i>`
          : state
      );
    }
  } else if (options.field3 === true) {
    if (content !== '') content += '  If the dispute is not resolved ';
    if (state === '') {
      content += answers[2].replace(
        '<STATE>',
        `<i><u>&nbsp;&nbsp;select a region&nbsp;&nbsp;</u></i>`
      );
      checked = false;
    } else {
      content += answers[2].replace(
        '<STATE>',
        state === 'extra_region'
          ? '<i><u>&nbsp;&nbsp;select a region&nbsp;&nbsp;</u></i>'
          : state
      );
    }
  }

  if (content === '') {
    return {
      content,
      checked: false,
    };
  } else {
    return {
      content: fixedContent + content,
      checked,
    };
  }
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/DisputeResolution.js